import React, { useCallback, useEffect, useRef, useState } from "react";
import { config } from "../../config";
import "../Shopkeeper/css/demo.css";
import "../Shopkeeper/css/ready.css";
import html2canvas from "html2canvas";
import Cropper from "react-easy-crop";
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { BsQuestionOctagon } from "react-icons/bs";

export default function AddPromo() {
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState(null);
  const [isPosting, setIsPosting] = useState(false);

  const fetchShopPromotions = async () => {
    const access_token = localStorage.getItem("accessToken");
    const locationId = localStorage.getItem("locationId");
    const userId = localStorage.getItem("userId");

    const url = `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion?page=0&offset=100&type=ALL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log(url);

      console.log("Promotions:", data);
      setPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchShopPromotions();
  }, []);

  const [image, setImage] = useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [overlayText, setOverlayText] = useState("");
  const [caption, setCaption] = useState("");
  const previewRef = useRef();

  const onImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(URL.createObjectURL(file));
    }
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // const handlePost = async () => {
  //   if (previewRef.current) {
  //     const canvas = await html2canvas(previewRef.current);
  //     const dataUrl = canvas.toDataURL();

  //     // This is where you'd send `dataUrl` to a backend or save it
  //     console.log('Posting image...', dataUrl);
  //   }
  // };

  const handlePost = () => {
    const fileInput = document.getElementById("imageInput");
    const file = fileInput?.files?.[0];

    if (!file) {
      console.error("No file selected");
      return;
    }

     setIsPosting(true);
    const overlayText = document.getElementById("overlayTextInput").value; // Get overlay text
    // const caption = document.getElementById("captionInput").value; // Assuming you have a caption input

    const reader = new FileReader();
    reader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Overlay text settings
        ctx.font = "30px Arial";
        ctx.fillStyle = "white";
        ctx.strokeStyle = "black";
        ctx.lineWidth = 2;

        // Positioning (bottom center)
        const textWidth = ctx.measureText(overlayText).width;
        const x = (canvas.width - textWidth) / 2;
        const y = canvas.height - 40;

        ctx.strokeText(overlayText, x, y); // outline
        ctx.fillText(overlayText, x, y); // fill

        // Convert canvas to Blob
        canvas.toBlob((blob) => {
          const formData = new FormData();
          formData.append("file", blob, "overlayed_image.png");
          formData.append("name", overlayText);
          formData.append("description", caption);

          // Step 1: Upload image
          fetch(`${config.api_base}api/v2/adoop/upload_image`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: formData,
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error(`Image upload failed: ${res.statusText}`);
              }
              return res.json();
            })
            .then((data) => {
              const imageId = data.imageId || data.image?.id || data.id;
              if (!imageId) {
                throw new Error("No image ID returned from upload");
              }

              // Step 2: Create promotion
              const userId = localStorage.getItem("userId");
              const payload = {
                image: imageId,
                validity_days: "ONE_DAY",
                name: overlayText,
                description: caption,
                special: "",
              };

              return fetch(
                `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion/new`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                      "accessToken"
                    )}`,
                  },
                  body: JSON.stringify(payload),
                }
              );
            })
            .then((res) => {
              if (!res.ok) {
                throw new Error(`Promotion creation failed: ${res.statusText}`);
              }
              return res.json();
            })
            .then((promotionData) => {
              console.log("Promotion created successfully:", promotionData);
              navigate("/shophome");
            })
            .catch((err) => {
              console.error("Error:", err.message);
            });
        }, "image/png");
      };
      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  };

  const navigate = useNavigate();

  const handleLogout = (e) => {
    // e.preventDefault();

    // const confirmLogout = window.confirm("Are you sure you want to logout?");
    // if (confirmLogout) {
      localStorage.clear();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId"); // Clear localStorage
      navigate("/"); // Navigate to home route
    // }
  };


    const [showModal, setShowModal] = useState(false);
    
      const handleShow = () => setShowModal(true);
      const handleClose = () => setShowModal(false);
    
      const confirmLogout = () => {
        handleLogout();
        handleClose();
      };
    
      
  return (
    <>
      {promotions && (
        <div className="wrapper">
        <div className="main-header">
            <div className="logo-header text-center">
              <a href="https://adoop.in/" target="_blank">
                <img
                  src="assets/img/logo/adoop-png.png"
                  style={{ width: "100px" }}
                  alt="logo"
                />
              </a>
              <button
                className="navbar-toggler sidenav-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="collapse"
                aria-controls="sidebar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <button className="topbar-toggler more">
                <i className="la la-ellipsis-v"></i>
              </button>
            </div>
            <nav className="navbar navbar-header navbar-expand-lg">
              <div className="container-fluid">
                <form
                  className="navbar-left navbar-form nav-search mr-md-3"
                  action=""
                >
                  {/* <div className="input-group">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fas fa-search"></i>
                      </span>
                    </div>
                  </div> */}
                </form>
                <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                  <li className="nav-item dropdown">
                    <a
                      className="profile-pic"
                      href="#"
                      aria-expanded="false"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`}
                        alt="user-img"
                        width="36"
                        className="img-circle"
                      />
                      <span>
                        Hello, {promotions?.shop?.name || "Shopkeeper"}
                      </span>{" "}
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                      <li>
                        <div className="user-box">
                          <div className="u-img">
                            <img src="assets/img/profile.jpg" alt="user" />
                          </div>
                          <div className="u-text">
                            <h4> {promotions?.shop?.name || "Shopkeeper"}</h4>
                            <p className="text-muted">kktannu60@.com</p>
                            <a
                              href="profile.html"
                              className="btn btn-rounded btn-danger btn-sm"
                            >
                              View Profile
                            </a>
                          </div>
                        </div>
                      </li>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#">
                        <i className="ti-user"></i> My Profile
                      </a>
                      <a className="dropdown-item" href="#">
                        {" "}
                        My Balance
                      </a>
                      <a className="dropdown-item" href="#">
                        <i className="ti-email"></i> Inbox
                      </a>
                      <div className="dropdown-divider"></div>

                      <a className="dropdown-item" href="#">
                        <i className="fa fa-power-off"></i> Logout
                      </a>
                    </ul>
                    {/* <!-- /.dropdown-user --> */}
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="sidebar">
            <div className="scrollbar-inner sidebar-wrapper">
              <ul className="nav">
                <li className="nav-item">
                  <Link to="/shophome" style={{ textDecoration: "none" }}>
                    <i class="fa-solid fa-house"></i>
                    <p>Home</p>
                  </Link>
                </li>
                <li className="nav-item active">
                  <Link to="/addpromotions" style={{ textDecoration: "none" }}>
                  <i class="bi bi-megaphone-fill"></i> 
                    <p>Promo</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/shopProfile" style={{ textDecoration: "none" }}>
                     <i class="bi bi-person-fill"></i>
                    <p>Profile</p>
                  </Link>
                </li>
                 <li className="nav-item">
                                <Link to="/shopPricing" style={{ textDecoration: "none" }}>
                                  <i class="bi bi-cash"></i>
                                  <p>My Subscription</p>
                                </Link>
                              </li>
                <li className="nav-item">
                    <Link
                  to="#"
                  onClick={handleShow}
                  style={{ textDecoration: "none" }}
                >
                  <i className="fa-solid fa-right-from-bracket"></i>
                  <p>Logout</p>
                </Link>

                {/* React Bootstrap Modal */}
                <Modal
                  show={showModal}
                  onHide={handleClose}
                  size="sm"
                  // centered
                  dialogClassName="custom-logout-modal"
                >
                  <Modal.Header closeButton className="modal-header-warning">
                    <Modal.Title style={{ fontSize: "18px", color: "#fff" }}>
                      Sign Out
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="d-flex align-items-center gap-2">
                    <BsQuestionOctagon size={20} className="text-dark" />
                    <span>Do you really want to sign out?</span>
                  </Modal.Body>
                  <Modal.Footer className="justify-content-end">
                    <Button
                      variant="outline-secondary"
                      className="btn-no"
                      onClick={handleClose}
                    >
                      No
                    </Button>
                    <Button
                      variant="light" // prevents default "primary" background
                      className="btn-yes ms-2"
                      style={{
                        backgroundColor: "#ffc600",
                        border: "none",
                        color: "black",
                      }}
                      onClick={confirmLogout}
                    >
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <h4 className="page-title">Add Promotions</h4>

               
                <div className="card">
                  <div className="card-body">
                    <div>
                      <label>Select Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        id="imageInput"
                        onChange={onImageChange}
                      />
                    </div>

                  

                    <div className="form-group mt-3">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        id="overlayTextInput"
                        value={overlayText}
                        onChange={(e) => setOverlayText(e.target.value)}
                        maxLength={100}
                      />
                    </div>

                    <div className="form-group">
                      <label>Caption</label>
                      <input
                        type="text"
                        className="form-control"
                        value={caption}
                        onChange={(e) => setCaption(e.target.value)}
                        maxLength={500}
                      />
                    </div>

                 
                    {image && (
                      <div
                        ref={previewRef}
                        style={{
                          position: "relative",
                          marginTop: 20,
                          border: "1px solid #ccc",
                          display: "inline-block", // So container wraps image naturally
                        }}
                      >
                        <img
                          src={image}
                          alt="Preview"
                          style={{
                            display: "block", // Removes unwanted gaps
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 10,
                            left: 10,
                            color: "white",
                            fontSize: 24,
                            textShadow: "1px 1px 3px black",
                            maxHeight: "90%", // Limit height
                            overflowY: "auto", // Scroll if too long
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            maxWidth: "90%",
                          }}
                        >
                          {overlayText}
                        </div>
                      </div>
                    )}

                    <div className="mt-3">
                      <strong>Caption Preview:</strong> {caption}
                    </div>

                    <button
                      className="btn btn-primary mt-3"
                      onClick={handlePost}
                    >
                      Post Promotion
                    </button>
                  </div>
                </div>
               
              </div>
            </div>
          </div> */}

          <div class="main-panel">
            <div class="content">
              <div class="container bg-white p-3 rounded mb-4 ">
                <h4 class="page-title">Add Promotions</h4>

                <div class="col-md-12">
                  <div class="p-3">
                    <div class="row ">
                      <div class="col-md-12 mb-3">
                        <label class="labels">Title</label>
                        {/* <input
                          type="text"
                          class="form-control"
                          placeholder="Enter your title"
                          value=""
                        /> */}
                         <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your title"
                        id="overlayTextInput"
                        value={overlayText}
                        onChange={(e) => setOverlayText(e.target.value)}
                        maxLength={100}
                      />
                      </div>
                      <div class="col-md-12 mb-3">
                        <label class="labels">Caption</label>
                        {/* <input
                          type="text"
                          class="form-control"
                          placeholder="Enter your caption"
                          value=""
                        /> */}
                         <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your caption"
                        value={caption}
                        onChange={(e) => setCaption(e.target.value)}
                        maxLength={500}
                      />
                      </div>
                    </div>

                    <div class="row">
                      <div class="container ">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <label class="labels">
                              Choose an image from your device{" "}
                            </label>
                            <div class="confirm-identity text-center border">
                              <div class="ci-user d-flex align-items-center justify-content-center">
                                <div class="ci-user-picture">
                                  <img
                                    src={image}
                                    id="item-img-output"
                                    class="img-fluid"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="ci-user-btn text-center mb-3">
                                <a
                                  href="#"
                                  class="userEditeBtn position-relative"
                                >
                                  {/* <input
                                    type="file"
                                    class="item-img filepreviewprofile"
                                  /> */}
                                   <input
                        type="file"
                        accept="image/*"
                        id="imageInput"
                        // class="item-img filepreviewprofile"
                        onChange={onImageChange}
                      />
                                  {/* Select Image */}
                                </a>
                              </div>
                            </div>

                            <div
                              class="modal fade cropImageModal"
                              id="cropImagePop"
                              tabindex="-1"
                              role="dialog"
                              aria-labelledby="cropImagePopLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <div class="modal-body p-0">
                                    <div class="modal-header-bg"></div>
                                    <div class="up-photo-content pb-5">
                                      <div
                                        id="upload-demo"
                                        class="center-block"
                                      >
                                        <h5 class="text-white text-center mt-2">
                                          <i class="fas fa-arrows-alt mr-1"></i>{" "}
                                          Drag your photo as needed
                                        </h5>
                                      </div>
                                      <div class="upload-action-btn text-center px-2 mt-4">
                                        <button
                                          type="button"
                                          id="useOriginalBtn"
                                          class="btn btn-secondary px-3 mr-2"
                                        >
                                          Use Original
                                        </button>
                                        <button
                                          type="button"
                                          id="cropImageBtn"
                                          class="btn btn-primary px-3 mr-2"
                                        >
                                          Crop Image
                                        </button>
                                        <button
                                          type="button"
                                          class="btn btn-danger px-3 replacePhoto"
                                        >
                                          Replace Image
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 mb-3">
                            <label class="labels">Caption Preview</label>
                            <p>
                            {caption}
                            </p>
                          </div>
                          <div class="col-md-12 mb-3">
                            <button
                              type="button"
                              href="#"
                               className="btn btn-block fa-lg login-btn btn-2 mb-3 px-4"
                               style={{width:"200px", height:"40px"}}
                              onClick={handlePost}
                              disabled={isPosting}
                            >
                               {isPosting ? "Posting..." : "Post Promotion"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
